<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Cadastro de regulador"
    >
        <Form
            :data="data"
            :original-regulador="originalRegulador"
            :regulador="regulador"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ regulador ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalRegulador: null,
        regulador: null,
    }),
    methods: {
        open(regulador = null) {

            this.resetForm()

            this.originalRegulador = regulador
            this.regulador = this.clone(regulador)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        },
        resetForm() {

            this.data.form.infraestruturas = []
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>